export const getSubscriptionOfferData = (useMockData = false) => {
  if (useMockData) {
    return Promise.resolve({
      json: () =>
        Promise.resolve({
          features: [],
          header: {
            subtitlep1: "",
            subtitlep2: "",
            subtitlep3: "",
            title: "",
            video: "",
            videoMobile: "",
            legalText: "",
          },
          offer: {
            bonus: "New subscribers get",
            description: "20 EXTRA Devon Home Tickets*",
            expireTime: 0,
            headline: "Claim now **£20** worth of tickets:",
            offerImage: "/assets/images/subscriptions/offer-image.webp",
            offerTitle: "FEW DAYS LEFT",
          },
        }),
    });
  }
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/GetPreSubscriptionModal`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getPassPageData = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/botbdynamiccontent/GetBotBPassData`);
